import React from 'react';
import { PaymentStatus } from '@apply/constants';
import { PaymentFilterBox } from './PaymentFilterBox';

export interface StatusCounts {
    inProgress: number;
    failure: number;
    refund: number;
    success: number;
    all: number;
}

export interface PaymentStatusFilterParameters extends StatusCounts {
    filterPaymentStatus: PaymentStatus | undefined;
    set_paymentStatus: React.Dispatch<React.SetStateAction<PaymentStatus | undefined>>;
}

export const PaymentStatusFilter: React.FC<PaymentStatusFilterParameters> = ({
    filterPaymentStatus,
    set_paymentStatus,
    all,
    success,
    inProgress,
    failure,
    refund,
}) => {
    return (
        <div className='box-filter'>
            <PaymentFilterBox
                set_paymentStatus={set_paymentStatus}
                paymentStatusType={undefined}
                count={all}
                isActive={filterPaymentStatus === undefined}
            />
            <PaymentFilterBox
                set_paymentStatus={set_paymentStatus}
                paymentStatusType={PaymentStatus.Success}
                count={success}
                isActive={filterPaymentStatus === PaymentStatus.Success}
            />
            <PaymentFilterBox
                set_paymentStatus={set_paymentStatus}
                paymentStatusType={PaymentStatus.InProgress}
                count={inProgress}
                isActive={filterPaymentStatus === PaymentStatus.InProgress}
            />
            <PaymentFilterBox
                set_paymentStatus={set_paymentStatus}
                paymentStatusType={PaymentStatus.Failure}
                count={failure}
                isActive={filterPaymentStatus === PaymentStatus.Failure}
            />
            <PaymentFilterBox
                set_paymentStatus={set_paymentStatus}
                paymentStatusType={PaymentStatus.Refund}
                count={refund}
                isActive={filterPaymentStatus === PaymentStatus.Refund}
            />
        </div>
    );
};
